<section class="qa-check-tab">
  <h2>{{ 'QA_LOG.QA_CHECKS' | translate }}</h2>
</section>
